import { SignalRCallbackByEvent, SignalREvent, useSignalR } from '../signalr';

export function useListenToServerEvent<TEventType extends SignalREvent>(
  signalREventType: TEventType,
  callback: SignalRCallbackByEvent[TEventType]
) {
  useSignalR(signalREventType, callback);
}
